var style = require('../icomoon/style.css');
module.exports = style;
